import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, Mail, Phone } from "lucide-react";
import { COMPANY } from "@/lib/data";

export default function NotFound() {
  useEffect(() => {
    // Hindra Google från att indexera 404-läget
    let robots = document.head.querySelector('meta[name="robots"]');
    const original = robots ? robots.getAttribute("content") : null;
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");
    return () => {
      if (robots && original !== null) robots.setAttribute("content", original);
    };
  }, []);

  return (
    <section className="min-h-[60vh] flex items-center justify-center py-20" data-testid="not-found">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center">
        <p className="font-display text-sm uppercase tracking-[0.18em] text-[#1E3A6F] mb-4">404</p>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 mb-4">
          Sidan kunde inte hittas
        </h1>
        <p className="text-lg text-slate-600 leading-relaxed mb-8">
          Sidan ni letar efter finns inte längre eller har flyttats. Kontakta oss gärna direkt
          eller gå tillbaka till startsidan.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to="/" data-testid="nf-home">
            <Button className="bg-[#1E3A6F] hover:bg-[#152a51] text-white rounded-full px-7 py-6 font-medium">
              <Home className="mr-2 h-4 w-4" /> Till startsidan
            </Button>
          </Link>
          <Link to="/kontakt#offertformular" data-testid="nf-kontakt">
            <Button variant="outline" className="border-2 border-[#1E3A6F] text-[#1E3A6F] hover:bg-slate-50 rounded-full px-7 py-6 font-medium">
              Kontakta oss
            </Button>
          </Link>
        </div>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-slate-600">
          <a href={COMPANY.phoneLink} className="flex items-center gap-2 hover:text-[#1E3A6F]" data-testid="nf-phone">
            <Phone className="h-4 w-4 text-[#F59E0B]" /> {COMPANY.phone}
          </a>
          <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-[#1E3A6F]" data-testid="nf-email">
            <Mail className="h-4 w-4 text-[#F59E0B]" /> {COMPANY.email}
          </a>
        </div>
      </div>
    </section>
  );
}
